module.exports={
  "_args": [
    [
      "cheerio@0.10.3",
      "C:\\Projects\\TBF\\Source"
    ]
  ],
  "_from": "cheerio@0.10.3",
  "_id": "cheerio@0.10.3",
  "_inBundle": false,
  "_integrity": "sha1-UBA9QuMO9KG/VSAB1oTs7nCCe2c=",
  "_location": "/production/cheerio",
  "_phantomChildren": {},
  "_requested": {
    "type": "version",
    "registry": true,
    "raw": "cheerio@0.10.3",
    "name": "cheerio",
    "escapedName": "cheerio",
    "rawSpec": "0.10.3",
    "saveSpec": null,
    "fetchSpec": "0.10.3"
  },
  "_requiredBy": [
    "/production"
  ],
  "_resolved": "https://registry.npmjs.org/cheerio/-/cheerio-0.10.3.tgz",
  "_spec": "0.10.3",
  "_where": "C:\\Projects\\TBF\\Source",
  "author": {
    "name": "Matt Mueller",
    "email": "mattmuelle@gmail.com",
    "url": "mattmueller.me"
  },
  "bugs": {
    "url": "https://github.com/MatthewMueller/cheerio/issues"
  },
  "dependencies": {
    "cheerio-select": "*",
    "entities": "0.x",
    "htmlparser2": "2.x",
    "underscore": "*"
  },
  "description": "Tiny, fast, and elegant implementation of core jQuery designed specifically for the server",
  "devDependencies": {
    "expect.js": "*",
    "mocha": "*"
  },
  "engines": {
    "node": ">= 0.6"
  },
  "homepage": "https://github.com/MatthewMueller/cheerio#readme",
  "keywords": [
    "htmlparser",
    "jquery",
    "selector",
    "scraper"
  ],
  "main": "./index.js",
  "name": "cheerio",
  "repository": {
    "type": "git",
    "url": "git://github.com/MatthewMueller/cheerio.git"
  },
  "scripts": {
    "test": "make test"
  },
  "version": "0.10.3"
}
